import { useMemo } from "react";
import Head from "next/head";
import { useRouter } from "next/router";
import { buildFaqPageSchema, serializeJsonLd } from "../lib/faq";

export default function FAQStructuredData({ items, pageUrl, id = "faq-page-schema" }) {
	const router = useRouter();
	const routeUrl = pageUrl || router.asPath || router.pathname || "/";

	const schema = useMemo(() => buildFaqPageSchema(items, routeUrl), [items, routeUrl]);

	if (!schema) {
		return null;
	}

	return (
		<Head>
			<script
				key={id}
				id={id}
				type="application/ld+json"
				dangerouslySetInnerHTML={{
					__html: serializeJsonLd(schema),
				}}
			/>
		</Head>
	);
}
